const pageOverlayActiveClass = 'body--showOverlayFull';
const overlayActiveClass = 'internshipOverlay--active';

const overlayButtons: NodeListOf<HTMLElement> = document.querySelectorAll('.js-internshipOverlayButton');
const overlayContent: NodeListOf<HTMLElement> = document.querySelectorAll('.js-overlayInternship');

export function internshipOverlay() {
  const overlayClose: NodeListOf<HTMLElement> = document.querySelectorAll('.js-overlayCloseInternship');

  overlayButtons.forEach((overlay) => {
    overlay.addEventListener('click', (event: Event) => {
      event.preventDefault();
      const type = overlay.dataset.type;
      overlay.classList.add(overlayActiveClass);
      document.body.classList.add(pageOverlayActiveClass);
      overlayContent.forEach((content) => {
        if (content.dataset.type === type) {
          content.classList.remove('hide');
        }
        const submitContent: HTMLElement | null = content.querySelector('.js-submitContent');
        if (submitContent)
          submitContent.addEventListener('click', () => {
            let checkboxText = '';
            const checkboxes: NodeListOf<HTMLInputElement> = content.querySelectorAll('.js-checkboxContent');
            checkboxes.forEach((checkbox) => {
              if (checkbox.checked) {
                const checkboxLabel = checkbox.closest('.js-checkboxWrapper')?.querySelector('.js-checkboxLabel')?.innerHTML;
                checkboxText += checkboxLabel + ' ';
              }
            });
            const inputTextContent: HTMLTextAreaElement | null = document.querySelector('.' + submitContent.dataset.target + ' textarea');
            if (inputTextContent) {
              inputTextContent.value = checkboxText;
            }
          });
      });
    });
  });

  overlayClose.forEach((close) => {
    close.addEventListener('click', (event: Event) => {
      closeOverlayInternship();
    });
  });

  /* close navigation on escape key or click on page overlay */
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeOverlayInternship();
    }
  });
  document.addEventListener('click', (event) => {
    const target = event.target as HTMLElement;
    if (target.classList.contains(pageOverlayActiveClass)) {
      console.log('hier');
      closeOverlayInternship();
    }
  });
}
export function closeOverlayInternship() {
  document.body.classList.remove(pageOverlayActiveClass);
  overlayContent.forEach((content) => {
    content.classList.add('hide');
  });
}
